module.exports = __webpack_public_path__ + "static/media/ic_gallery.d0734e2b.png";